import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import classnames from 'classnames'

import FeedListLoader from 'app/domains/common/Loaders/FeedListLoader'
import FeedListItemLoader from 'app/domains/common/Loaders/FeedListItemLoader'
import FeedEmpty from '../FeedEmpty'
import FeedStoriesListItem from './FeedStoriesListItem'

const FeedList = ({
  storiesList,
  pending,
  handleScroll,
  pendingLoadMore,
  identity,
  handleSetFeedStoryLikeOld,
  setStoryReaction,
  updateReaction,
  showReactions,
  loadStoryActivity,
}) => (
  <div className="feed-list-wrapper">
    {pending ? (
      <FeedListLoader />
    ) : storiesList.size ? (
      <div className={classnames('feed-list', { 'load-more': pendingLoadMore })}>
        <Scrollbars
          onScroll={handleScroll}
          autoHeight
          autoHeightMax={580}
          renderThumbVertical={props => <div {...props} className="scrollbar-thumb-vertical" />}
        >
          {storiesList.map((item, i) => (
            <FeedStoriesListItem
              index={i}
              key={i}
              {...item.toJS()}
              identity={identity}
              setReaction={setStoryReaction}
              updateReaction={updateReaction}
              handleSetFeedStoryLikeOld={handleSetFeedStoryLikeOld}
              showReactions={showReactions}
              loadStoryActivity={loadStoryActivity}
            />
          ))}
          {pendingLoadMore ? <FeedListItemLoader /> : null}
        </Scrollbars>
      </div>
    ) : (
      <FeedEmpty listType="stories" />
    )}
  </div>
)

export default FeedList
